import { z } from "zod";

import { DbEnum } from "../../../../generated/prisma-enums";
import { ModelConfigSchema } from "../../../../schemas/ModelConfig/model-config.schema";

export const AGENT_STATUS_VALUES = DbEnum.AGENT_STATUS_VALUES;
export const AgentStatusSchema = z.enum(AGENT_STATUS_VALUES);
export type AgentStatus = z.infer<typeof AgentStatusSchema>;

/**
 * Single canonical Agent type for the frontend.
 *
 * Required fields are always present (returned by the list endpoint).
 * Optional fields are populated by more detailed fetches (e.g. with relations).
 */
export const AgentSchema = z.object({
  id: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  profile_picture: z.string().nullable(),
  short_bio: z.string().optional(),
  role: z.string().nullable(),
  bio: z.string(),
  tags: z.string(),
  gender: z.string(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date().nullable(),
  status: AgentStatusSchema,
  modelConfig: ModelConfigSchema.nullable(),
  playgroundFirstMessage: z.string().nullable(),
  // Optional — populated when fetching with relations
  organizationId: z.string().nullish(),
  details: z.string().nullish(),
  AgentTasks: z
    .array(z.object({ id: z.string(), action: z.string(), descriptionHL: z.string() }))
    .optional(),
  agentTools: z.array(z.object({ id: z.string() })).optional(),
  ToolActionConfig: z
    .array(z.object({ id: z.string(), publicName: z.string(), description: z.string() }))
    .optional(),
  knowers: z
    .array(
      z.object({ id: z.string(), name: z.string(), description: z.string(), isTool: z.boolean() })
    )
    .optional(),
  agentFlows: z
    .array(z.object({ id: z.string(), publicName: z.string(), description: z.string() }))
    .optional(),
  isFavorite: z.boolean().default(false)
});

export type Agent = z.input<typeof AgentSchema>;
